import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, computed } from 'vue';
import { ArrowRightIcon } from '@tencent/wphk-icon-vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useRouter } from 'vue-router/composables';
import { ModuleName } from '@/types/module-type';
import { MerchantDpList } from '@/types/merchant';
import HotMerchantSkeleton from '@/components/skeleton/travel-tool-skeleton.vue';
import { i18n } from '@/i18n';
import { useConfigStore, useDpStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'hot-merchant',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




const router = useRouter();

// store
const { getConfig } = useConfigStore();
const dpStore = useDpStore();

const isReady = ref(false);


// 热门商户卡片
const hotMerchantDpList = ref<MerchantDpList[]>([]);
const showHotMerchantDpList = computed(() => hotMerchantDpList.value.filter(item => item.isHomeShow));
// 进入推荐详情
function goToMerchantDetail(contentPosition: string) {
  router.push({ name: 'merchantDetail', query: { id: contentPosition } });
}
// 点击查看全部
const onClickMore = () => {
  router.push({ name: 'merchantDetail' });
};

onBeforeMount(async () => {
  const { isMerchantInited, merchantDpList } = dpStore;
  if (!isMerchantInited) {
    const { merchantDpList } = await getConfig(props.moduleName);
    hotMerchantDpList.value = merchantDpList;
  } else {
    hotMerchantDpList.value = merchantDpList;
  }

  isReady.value = true;

  // 没有内容隐藏该模块
  if (!hotMerchantDpList.value.length) {
    emit('onHideModule', props.moduleName);
  }
});

return { __sfc: true,props, emit, router, getConfig, dpStore, isReady, hotMerchantDpList, showHotMerchantDpList, goToMerchantDetail, onClickMore, ArrowRightIcon, ThemeCard, HotMerchantSkeleton, i18n }
}

})